export function tryParseJSON<T>(
	jsonString: string,
	useThrow: boolean = false,
): T | null {
	try {
		return JSON.parse(jsonString) satisfies T;
	} catch (error) {
		if (useThrow) {
			throw error;
		}
		window.awxLogger
			?.withScope('tagEngine::tryParseJSON')
			.error('Could not parse JSON data.', { jsonString, error });
		return null;
	}
}
